import React, { useEffect } from "react";
import Helper from "../../common/helper";
import clsx from "clsx";
import { Add, Selected, AdvantageCheckIcon } from "../../common/icons";
import { MembershipHeader } from "./multi-card";
import ProductPricePoints from "../UI/product-price-points";
import { travellerBenefits } from "../../assets/benefits/benefits";
import { getAltItemDescription } from "../../common/utils";

const isCampaign1363 = Helper.isVNCampaign();

export const AdvantagesList = ({ advantageText, id }) =>
  // console.log('advantageText', advantageText)
  advantageText && (
    <div className="flex gap-4">
      <div>
        <AdvantageCheckIcon className="w-6 h-6" />
      </div>
      
      <p className="font-montserrat font-normal text-base text-left">
        {id === 0 && <div><span className="font-semibold">LIMITED TIME OFFER</span></div>}{advantageText}

        {/* id === 0 is to MATCH the QBR content */}
      </p>
    </div>
);

export const getAllExplorerContent = (languages, benefitsTranslations) => {
    const itemName = 'ALL Accor+ Explorer'
      let AllExplorerPlusBenefits =
        benefitsTranslations.benefits[4]["all explorer"];
    return (
      <React.Fragment>       
      {getTitle(itemName, languages.newDate)}
      <ul className="membership-inclusions membership-allproduct">
        {
        AllExplorerPlusBenefits.map(
          (
            advantage,
            id // non-qbr
          ) => (
            <li
              key={id}
              className={clsx({
                "mt-1": id === 0,
                "mt-1": id !== 0
              })}
            >
              <AdvantagesList
                advantageText={
                  advantage[benefitsTranslations.region]
                }
              />
            </li>
          )
        )}
      </ul>
    </React.Fragment>
    );
};

export const getBusinessExplorerContent = (languages, benefitsTranslations) => {
  console.log('benefitsTranslations', benefitsTranslations)
    const itemName = 'Accor Plus Explorer'
      let QantasBusinessRewards = [
        {au: '10,000 Qantas Points PLUS 3,000 ALL Reward Points'},
        {au: '1 complimentary night in Asia Pacific'},
        {au: 'Up to 50% off Red Hot Rooms in Asia Pacific'},
        {au: 'Up to 50% off on dining in Asia Pacific'},
        {au: '15% discount on drinks in Asia'},
        {au: '10% off hotel stays in Asia Pacific'},
        {au: '20 ALL Accor Status Nights'},
        {au: 'Exclusive events and offers'},
      ]
    return (
      <React.Fragment>       
      {getTitle(itemName, languages.currentDate)}
      <ul className="membership-inclusions membership-allproduct">
        {
        QantasBusinessRewards.map(
          (
            advantage,
            id // non-qbr
          ) => (
            <li
              key={id}
              className={clsx({
                "mt-1": id === 0,
                "mt-1": id !== 0
              })}
            >
              <AdvantagesList
                advantageText={
                  advantage['au']
                }
                id={id}
              />
            </li>
          )
        )}
      </ul>
    </React.Fragment>
    );
};

export const getTitle = (itemName, content) => {
  return (
    <React.Fragment>
      <div className="mt-4 mb-2">
        <p className="font-semibold">
          <span className='text-capitalize'>{itemName}</span> 
          <span> benefits</span>                      
        </p> 
      </div>

      <div className="mb-4">
        <p className="text-uppercase text-base benefits-text">{content
          ? content
          : "Now until 30 Sep, 2025"}</p>
      </div>
    </React.Fragment>
  )
}

export default function SingleCard({
  benefitsTranslations,
  product,
  selectMembership,
  couponObj,
  isUserLogged,
  locationDataCurrency,
  languages,
  locationData,
  businessCategories,
  refundWidgetToggle
}) {
  let item = product[0];
    const {
    business_category_id,
    item_group_id,
  } = item || {};
  let totalAmt = parseFloat(item.purchase_price) + parseFloat(item.tax_amt);
  let discountAmt = (
    parseFloat(item.purchase_base_price) + parseFloat(item.base_tax_amt)
  ).toLocaleString("en-US");
  let currency = item.currency_text ? item.currency_text : locationDataCurrency;
  let membershipText = item.item_group_description;
  const component_items = item.component_items || item.item_group_components;
  const foc = Helper.focLength(component_items);
  const getCoupon = Helper.checkCoupon(item, couponObj);
  const PWP = Helper.newpwpCheck(
    item,
    isUserLogged,
    locationData,
    businessCategories
  );
  const DiscoveryMembership = item.item_group_name.includes("DISCOVERY")
    ? true
    : false;
  const ExplorerMembership = item.item_group_name.includes("EXPLORER")
    ? true
    : false;
  const travellerMembership = item.item_group_name.includes("TRAVELLER")
    ? true
    : false;
  const ExplorerPlusMembership =
    item.item_group_name && item.item_group_name.includes("EXPLORER PLUS")
      ? true
      : false;
  const getVoucherDetails = Helper.voucherBenefitsChecker(locationData.country);
  const isDBS = Helper.isDBS();
  const isAMEX = Helper.isAMEX();
  const isSCB = Helper.isSCB();
  let isQbr = item.isQbr ? true : false;
  const itemGroupId = item_group_id;
  const altItemDescription = getAltItemDescription(businessCategories, business_category_id, itemGroupId);
  const itemName = altItemDescription || membershipText
    .replace(/ACCOR PLUS | MEMBERSHIP/gi, "")
    .trim();
  const isBasePrice = item.priceLevel?.includes("BASE PRICE");
  let TravellerBenefits = benefitsTranslations.benefits[0].traveller;
  let ExplorerBenefits = benefitsTranslations.benefits[1].explorer;
  let ExplorerPlusBenefits = benefitsTranslations.benefits[2]["explorer plus"];


  let discount =
    parseFloat(item.purchase_base_price) > parseFloat(item.purchase_price);

  function getPWPComponent(languageMessage, defaultMessage) {
    return (
      <div className="py-3">
        <span className="font-montserrat font-medium total-amount">
          {PWP.points}
        </span>
        <span className="font-montserrat font-medium uppercase">
          {" "}
          {languageMessage ? languageMessage : defaultMessage}
        </span>
      </div>
    );
  }

  useEffect(() => {
    selectMembership(item);
  }, []);

  return (
    <div
      className={clsx(
        "card flex bg-white desktop:hover:scale-105 duration-500",
        {
          selected: item.isSelected ? true : false,
        }
      )}
      onClick={() => selectMembership(item)}
    >
      <div className="content-holder flex flex-col h-full">
        <div className="flex flex-col h-full p-5">
          <MembershipHeader isSelected={item.isSelected} itemName={itemName} />
          <div className="holder-text">
            <ProductPricePoints
              currency={currency}
              totalAmt={totalAmt}
              isUserLogged={isUserLogged}
              isQbr={isQbr}
              languages={languages}
              PWP={PWP}
              getCoupon={getCoupon}
              item={item}
              locationData={locationData}
              getPWPComponent={getPWPComponent}
            />

            {/* <div className="py-3">
              <p className="font-montserrat font-bold">
                {languages.enjoyBenefits
                  ? languages.enjoyBenefits
                  : "ENJOY ACCOR PLUS UNIVERSAL BENEFITS"}
              </p>
            </div> */}
            
          </div>

          {/* Added for CVP */}
          {refundWidgetToggle && ExplorerMembership && !isQbr && getTitle(itemName, languages.currentDate)}
          {/* Benefits Start */}

          <ul className="membership-inclusions">
            
            {/* {foc !== 0 && isQbr && languages.qbrFreeHotel && (<div className="">
              <p className="font-montserrat align-middle">
                <Add/> {languages.qbrFreeHotel ? languages.qbrFreeHotel : "Free Hotel Night"}
              </p>
            </div>)} */}

            {travellerMembership &&
              TravellerBenefits.map((advantage, id) => (
                // console.log('advantage', advantage)
                <li
                  key={id}
                  className={clsx({
                    "mt-4": id === 0,
                    "mt-1": id !==0
                  })}
                >
                  <AdvantagesList
                    advantageText={advantage[benefitsTranslations.region]}
                  />
                </li>
              ))}

            {DiscoveryMembership && (
              <React.Fragment>
                {languages.discoveryMembershipCustomMessageList1 ? (
                  <li className="inclusion-list flex items-center">
                    <AdvantagesList
                      advantageText={
                        languages?.discoveryMembershipCustomMessageList1 ||
                        "Earn 1,000 Discovery Dollars"
                      }
                    />
                  </li>
                ) : (
                  <></>
                )}

                {languages.discoveryMembershipCustomMessageList2 ? (
                  <li className="inclusion-list flex items-center">
                    <AdvantagesList
                      advantageText={
                        languages?.discoveryMembershipCustomMessageList2 ||
                        "10% savings on membership(RRP $498)"
                      }
                    />
                  </li>
                ) : (
                  <></>
                )}

                <li className="inclusion-list flex items-center">
                  <AdvantagesList
                    advantageText={
                      languages?.discoveryMembershipMessage ||
                      "Amazing cruise, tour and wine offers worldwide"
                    }
                  />
                </li>
              </React.Fragment>
            )}
            {/* {foc !== 0 && (
              <li className="inclusion-list flex items-center">
                {foc > 1 ? (
                  <AdvantagesList
                    advantageText={
                      languages?.productFocAvailableMultipleMessage ||
                      "Stay Plus complimentary nights"
                    }
                  />
                ) : (
                  <AdvantagesList
                    advantageText={
                      languages?.productFocAvailableSingleMessage ||
                      "Complimentary night stay at participating hotels"
                    }
                  />
                )}
              </li>
            )} */}
            {ExplorerMembership &&
            isBasePrice &&
            !ExplorerPlusMembership &&
            !isQbr &&
            languages.productBonusRewardPoints ? (
              <li className="inclusion-list flex items-center">
                <AdvantagesList
                  advantageText={
                    languages?.productBonusRewardPoints ||
                    "Bonus 2,000 Reward Points (For a limited time)"
                  }
                />
              </li>
            ) : (
              <></>
            )}    
            {foc !== 0 && refundWidgetToggle &&
              !isQbr && !isSCB &&
              ExplorerMembership &&
              ExplorerBenefits?.map(
                (
                  advantage,
                  id // non-qbr
                ) => (
                  <li
                    key={id}
                    className={clsx({
                      "mt-1": id === 0,
                      "mt-1": id !==0
                    })}
                  >
                    <AdvantagesList
                      advantageText={advantage[benefitsTranslations.region]}
                    />
                  </li>
                )
              )}
            {foc !== 0 &&
              !isQbr &&
              ExplorerPlusMembership &&
              ExplorerPlusBenefits.map(
                (
                  advantage,
                  id // non-qbr
                ) => (
                  <li
                    key={id}
                    className={clsx({
                      "mt-1": id === 0,
                      "mt-1": id !==0
                    })}
                  >
                    <AdvantagesList
                      advantageText={advantage[benefitsTranslations.region]}
                    />
                  </li>
                )
              )}
              {DiscoveryMembership && getVoucherDetails[1].discovery && !isAMEX && (
              <li>
                <AdvantagesList
                  advantageText={
                    languages?.productVoucherBenefitsDiscovery ||
                    " Exclusive dining and accommodation discount vouchers"
                  }
                />
              </li>
            )}
            {ExplorerMembership && getVoucherDetails[0].explorer && !isAMEX && (
              <li>
                <AdvantagesList
                  advantageText={
                    languages?.productVoucherBenefitsExplorer ||
                    " Exclusive dining and accommodation discount vouchers"
                  }
                />
              </li>
            )}
            {ExplorerMembership && isCampaign1363 && (
              <li className="flex gap-4">
                <div>
                  <AdvantageCheckIcon className="w-6 h-6" />
                </div>
                <p className="font-montserrat font-normal text-base text-left">
                  Cash voucher package worth VND 2,000,000 when paying with a
                  VISA Signature or VISA Infinite card. Terms and Conditions
                  apply.
                </p>
              </li>
            )}
          </ul>

          {/* For new CVP */}

            {refundWidgetToggle && ExplorerMembership && isQbr &&
              <div>
                {getBusinessExplorerContent(languages, benefitsTranslations)}
              </div>
            }


            {refundWidgetToggle && ExplorerMembership &&
              <div>
                {getAllExplorerContent(languages, benefitsTranslations)}
              </div>
            }

        </div>
      </div>
    </div>
  );
}
